import useMedia from "../../../modules/media/hooks";
import React from "react";
import { Nav } from "shards-react";

import SidebarNavItem from "./SidebarNavItem";
import useAuth from "../../..//modules/auth/hooks";

const SidebarNavItems = () => {
  const { fetchAllMedias } = useMedia();
  const { getProfile, auth } = useAuth();
  const clickProfile = () => {

    if (window.sessionStorage.getItem('userid') && !auth.user.email) {
      getProfile(window.sessionStorage.getItem('userid'))
    }
  };
  const items = [
    {
      title: "미디어 관리",
      htmlBefore: '<i class="material-icons">article</i>',
      to: "/medias",
      onClick: fetchAllMedias
    },
    {
      title: "문의사항",
      htmlBefore: '<i class="material-icons" style={{width: "20px"}}>help_icon</i>',
      to: "/inquiry"
    },
    {
      title: "유저관리",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/user",
      onClick: clickProfile()
    },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors"
    // },
    // {
    //   title: "Forms & Components",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/components-overview"
    // }
  ];

  return (
    <div className="nav-wrapper">
      <Nav className="nav--no-borders flex-column">
        {items.map((item, idx) => (
          <SidebarNavItem key={idx} item={item} />
        ))}
      </Nav>
    </div>
  );
};

export default SidebarNavItems;
